<template>
  <div class="w-full flex flex-col" style="max-width: 500px;">
    <!-- AGENCY CARD -->
    <div class="agency-card w-full flex flex-col p-1 border border-border-normal">
      <div class="w-full flex flex-col gap-7 p-4">
        <!-- Avatar & Status -->
        <div class="flex w-full justify-between">
          <img v-if="listing.avatar?.length" :src="listing.avatar" class="rounded-lg" style="width: 64px; height: 64px;">
          <div v-else class="rounded-lg bg-neutral-25" style="width: 64px; height: 64px;" />
          <div class="flex items-center p-0.5 rounded-md bg-secondary-green-10 h-7">
            <BaseText type="body" size="sm" class="text-secondary-green-300 px-1.5 py-0.5">
              Status
            </BaseText>
            <div class="w-0 h-3 border-l border-secondary-green-300 mx-0.5 opacity-20" />
            <BaseText type="label" size="sm" class="text-secondary-green-300 px-1.5 py-0.5">
              Published
            </BaseText>
          </div>
        </div>
        <!-- Name Information -->
        <div class="w-full flex flex-col gap-2">
          <div class="agency-name text-text-muted">
            {{ listing.agencyName }}
          </div>
          <!-- Verified Badge -->
          <div class="flex items-center gap-1">
            <VerifiedBadgeIcon :width="20" :height="20" />
            <BaseText type="label" size="sm" class="text-text-muted">
              Verified Agency
            </BaseText>
          </div>
          <!-- Lead Intro Email -->
          <div class="flex items-center gap-1">
            <EmailIcon class="text-icon-normal" />
            <BaseText type="label" size="sm" class="text-text-muted">
              Leads sending to {{ listing.leadIntroEmail }}
            </BaseText>
          </div>
        </div>
      </div>
      <!-- Actions -->
      <div class="grid grid-cols-2 gap-2 p-2">
        <button class="secondary-btn w-full flex items-center justify-center gap-1.5 px-2 py-1.5 rounded-md"
        @click="handleViewListing">
          <ViewIcon class="text-icon-normal" />
          <BaseText type="label" size="sm" class="text-text-muted">
            View Listing
          </BaseText>
        </button>
        <button class="secondary-btn w-full flex items-center justify-center gap-1.5 px-2 py-1.5 rounded-md"
        @click="handleEditListing">
          <EditIcon class="text-icon-normal" />
          <BaseText type="label" size="sm" class="text-text-muted">
            Edit Listing
          </BaseText>
        </button>
      </div>
    </div>
    <!-- AGENCY BADGES -->
    <div class="w-full flex flex-col gap-1 mt-8">
      <BaseText type="label" size="sm" class="text-text-muted">
        Your Foreplay Agency Badge
      </BaseText>
      <BaseText type="body" size="sm" class="text-text-normal" style="max-width: 400px;">
        Showcase your agency’s reputation with a badge clients instantly recognize.
      </BaseText>
    </div>
    <!-- BADGE PREVIEWS -->
    <div class="w-full flex flex-col gap-4 mt-8">
      <div v-for="(badge, index) in badges" :key="`badge-${index}`"
      class="badge-preview-card w-full p-1 border border-border-normal">
        <!-- Label & Actions -->
        <div class="w-full flex flex-col p-2">
          <BaseText type="label" size="sm" class="text-text-normal capitalize">
            {{ badge.style }} Mode
          </BaseText>
          <button class="secondary-btn w-full flex items-center justify-center gap-1.5 px-2 py-1.5 rounded-md mt-8"
          v-clipboard:copy="createEmbedCode(badge.style)" v-clipboard:success="handleEmbedClipboardCopy">
            <EmbedSquareIcon class="text-icon-normal" />
            <BaseText type="label" size="sm" class="text-text-muted">
              Embed
            </BaseText>
          </button>
          <button class="secondary-btn w-full flex items-center justify-center gap-1.5 px-2 py-1.5 rounded-md mt-3"
          @click="handleSVGDownload(badge.style)">
            <DownloadSquareIcon class="text-icon-normal" />
            <BaseText type="label" size="sm" class="text-text-muted">
              Download SVG
            </BaseText>
          </button>
        </div>
        <!-- Preview -->
        <div class="w-full h-full flex items-center justify-center rounded-xl" 
        :class="badge.style === 'light' ? 'bg-neutral-25' : 'bg-neutral-900'">
          <component v-if="badge.badgePreview" :is="badge.badgePreview" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// Badge Previews
import ForeplayAgencyBadgeLight from './badges/ForeplayAgencyBadgeLight.vue'
import ForeplayAgencyBadgeDark from './badges/ForeplayAgencyBadgeDark.vue'

// Icons
import VerifiedBadgeIcon from '../../globals/Icons/AgencyIcons/VerifiedBadgeIcon.vue'
import EmailIcon from '../../globals/Icons/EmailIcon.vue'
import ViewIcon from '../../globals/Icons/ViewIcon.vue'
import EditIcon from '../../globals/Icons/EditIconV2.vue'
import EmbedSquareIcon from '../../globals/Icons/EmbedSquareIcon.vue'
import DownloadSquareIcon from '../../globals/Icons/DownloadSquareIcon.vue'

// Badge SVGs
import lightBadgeSrc from '../../../assets/badges/agency-badge-light.svg'
import darkBadgeSrc from '../../../assets/badges/agency-badge-dark.svg'

export default {
  name: 'ViewDirectoryListing',
  components: {
    VerifiedBadgeIcon,
    EmailIcon,
    ViewIcon,
    EditIcon,
    EmbedSquareIcon,
    DownloadSquareIcon
  },
  props: {
    listing: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      badges: [
        {
          style: 'light',
          badgePreview: ForeplayAgencyBadgeLight
        },
        {
          style: 'dark',
          badgePreview: ForeplayAgencyBadgeDark
        }
      ]
    }
  },
  methods: {
    handleViewListing () {
      window.open(this.listing.listingUrl, '_blank')
    },
    handleEditListing () {
      this.$emit('editListing', this.listing)
    },
    handleSVGDownload (style) {
      try {
        const isLight = style === 'light'
        const fileSrc = isLight ? lightBadgeSrc : darkBadgeSrc
        const filename = `foreplay-agency-badge-${style}.svg`

        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = fileSrc
        a.setAttribute('download', filename)

        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } catch (error) {
        console.error('Error downloading SVG:', error)
        this.$showAlert({ type: 'error', message: 'Error downloading SVG' })
      }
    },
    createEmbedCode (style) {
      const randomlyGeneratedId = Math.random().toString(36).substring(7)
      const base = process.env.VUE_APP_API_URL
      return `<iframe id="${randomlyGeneratedId}" src="${base}/embed/static/agency-badge?style=${encodeURIComponent(style)}&listingUrl=${encodeURIComponent(this.listing.listingUrl)}" width="140" height="44" style="border:0;width:140px;height:44px;" scrolling="no" frameborder="0"></iframe>`
    },
    handleEmbedClipboardCopy () {
      this.$showAlert({
        message: 'Copied embed code to clipboard',
        type: 'success'
      })
    }
  }
}
</script>

<style scoped>
.agency-card {
  border-radius: 18px;
  box-shadow: 0 2px 1px 0 rgba(255, 255, 255, 0.12) inset;
}
.agency-name {
  /* Display/H6 */
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 140% */
  letter-spacing: -0.11px;
}
.badge-preview-card {
  display: grid;
  grid-template-columns: 204px 1fr;
  gap: 8px;
  border-radius: 18px;
}

.secondary-btn {
  box-shadow: 0 1px 2px 0 rgba(4, 26, 75, 0.13), 0 0 0 1px rgba(0, 56, 108, 0.08);
  background-color: transparent;
  transition: background-color 100ms ease-in-out, box-shadow 100ms ease-in-out;
}
.secondary-btn:hover {
  box-shadow: none;
  background-color: #F6F8FA;
}
</style>